import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem("cart");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems((prev) => {
      const match = prev.find(
        (p) =>
          p.name === item.name &&
          p.color === item.color &&
          p.size === item.size
      );
      if (match) {
        return prev.map((p) =>
          p === match ? { ...p, quantity: p.quantity + item.quantity } : p
        );
      }
      return [...prev, item];
    });
  };

  const updateQuantity = (itemKey, newQty) => {
    setCartItems((prev) =>
      newQty === 0
        ? prev.filter((_, i) => i !== itemKey)
        : prev.map((item, i) => (i === itemKey ? { ...item, quantity: newQty } : item))
    );
  };

  const removeFromCart = (itemToRemove) => {
    setCartItems((prev) =>
      prev.filter(
        (item) =>
          !(
            item.name === itemToRemove.name &&
            item.color === itemToRemove.color &&
            item.size === itemToRemove.size
          )
      )
    );
  };

  const consumeFromCart = (itemToConsume, consumedQuantity = 1) => {
    const amount = Math.max(1, Number(consumedQuantity) || 1);
    setCartItems((prev) =>
      prev.flatMap((item) => {
        const matches =
          item.name === itemToConsume.name &&
          item.color === itemToConsume.color &&
          item.size === itemToConsume.size;
        if (!matches) return [item];
        const nextQuantity = Number(item.quantity || 0) - amount;
        return nextQuantity > 0 ? [{ ...item, quantity: nextQuantity }] : [];
      })
    );
  };

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <CartContext.Provider value={{
      cartItems,
      addToCart,
      updateQuantity,
      removeFromCart,
      consumeFromCart,
      cartCount,
    }}>
      {children}
    </CartContext.Provider>
  );
};
